export enum PlanCode {
  LITE = 'LITE',
  PRO = 'PRO',
  TEAM_STARTER = 'TEAM_STARTER',
  TEAM_PRO = 'TEAM_PRO',
  ENTERPRISE = 'ENTERPRISE',
  STANDARD = 'STANDARD',
  UNLIMITED = 'UNLIMITED',
  UNLIMITED_ONE_YEAR = 'UNLIMITED_ONE_YEAR',
}

export type PendingSubscriptionChangeResponse = {
  hasPendingChange: boolean
  scheduleId: string
  effectiveAt: number
  currentPlan: PlanCode
  currentSeats: number
  targetPlan: PlanCode
  targetSeats: number
}

export type Subscription = {
  id: string
  stripeSubscriptionId: string
  validTo: string
  startAt: string
  cancelAt?: string
  tokens: number
  remainingTokens: number
  seats: number
  productName?: string
  productPrice?: string
  productId?: string
  hasEnoughSeats?: boolean
  trialEnd?: string
  currentPeriodEnd?: string
  paymentDetails?: {
    brand: string
    last4: string
    expMonth: number
    expYear: number
  }
  currentPlan: PlanCode
}
